import { Box } from '@src/atoms/Box';
import { DatePicker } from '@src/atoms/DatePicker';
import { cloneDeep } from 'lodash';
import React, { FC, useCallback, useState } from 'react';
import { TControllerValue, TDateRange } from '../../models';
import { useSyncFilterValue } from '../../useSyncValue';
import { ISwipeDialogComponentProps } from '../models';
import { FilterSwipeDialogWrapper } from '../_Wrapper/FilterSwipeDialogWrapper';
import { DISPLAY_FORMAT, LABEL_FROM, LABEL_TO } from './consts';
import { FiltersSwipeDialogDateRangeItem } from './FiltersSwipeDialogDateRangeItem';

type TDateOpen = 0 | 1 | false;

export const FiltersSwipeDialogDateRange: FC<ISwipeDialogComponentProps> = ({
  controller,
  loading,
  resultText,
  filter,
  setActiveFilterName,
}) => {
  const appliedValues = useSyncFilterValue({ controller, event: filter.name }) as TControllerValue<TDateRange>;
  const [open, setOpen] = useState<TDateOpen>(false);
  const [value, setValue] = useState(cloneDeep(appliedValues?.value || null));

  const handleClose = () => {
    setActiveFilterName(null);
  };

  const handleSubmit = () => {
    controller.onChange(filter.name, value);
    handleClose();
  };

  const handleChange = useCallback(
    (v) => {
      if (typeof open !== 'number') return;
      const newValues = value || [null, null];

      //https://centrateam.atlassian.net/browse/CA-3625
      /**
       * Т.к. все даты в базе у нас в UTC без таймзоны, для корректной фильтрации даты "ПО",
       * мы возьмем время 23:59:59 у указанной даты
       **/
      if (open === 1 && v) {
        const date = new Date(v);
        date.setHours(23);
        date.setMinutes(59);
        date.setSeconds(59);

        const vv = date.toISOString();
        newValues[open] = vv;
      } else {
        /** Здесь мы вернем null если вдруг v = '' */
        newValues[open] = v || null;
      }

      setValue([...newValues]);
      setOpen(false);
    },
    [open, value],
  );

  const handleChangeDateOpen = useCallback((v: TDateOpen) => () => setOpen(v), []);

  const [first = null, second = null] = value || [];

  if (typeof open === 'number') {
    return (
      <FiltersSwipeDialogDateRangeItem
        name={filter.name}
        title={filter.title}
        label={open === 0 ? LABEL_FROM : LABEL_TO}
        value={(value || [])[open]}
        onSubmit={handleChange}
        onClose={handleChangeDateOpen(false)}
      />
    );
  }

  return (
    <FilterSwipeDialogWrapper
      title={filter.title}
      loading={loading}
      resultText={resultText}
      onBack={handleClose}
      onSubmit={handleSubmit}
    >
      <Box padding={16} fullWidth gap={8}>
        <DatePicker
          id={filter.name}
          format={DISPLAY_FORMAT}
          postIcon="calendar"
          label={LABEL_FROM}
          open={false}
          value={first || ''}
          onFocus={handleChangeDateOpen(0)}
        />
        <DatePicker
          id={filter.name}
          format={DISPLAY_FORMAT}
          postIcon="calendar"
          label={LABEL_TO}
          open={false}
          value={second || ''}
          onFocus={handleChangeDateOpen(1)}
        />
      </Box>
    </FilterSwipeDialogWrapper>
  );
};
